import React from 'react'
import CheckoutPage from './components/CheckoutPage'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const Index = () => {

    const key = process.env.REACT_APP_STRIP_KEY;
    const stripePromise = loadStripe(key);


    return (
        <Elements stripe={stripePromise}><CheckoutPage/></Elements>
    )
}

export default Index
